import React, { useEffect, useState } from "react";
import {helpers} from '../../helper/helper';
import SweetAlert from 'sweetalert2-react';
import { Link } from "react-router-dom";
// import { Button } from "@material-ui/core";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";

const AdminEngagementTasksConfig = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [confirmPopup, setConfirmPopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  const getNormalizedConfig = (rawConfig = {}) => {
    return {
      ...rawConfig,
      adClaim: {
        starPoint: rawConfig?.adClaim?.starPoint ?? rawConfig?.adClaim?.starpoint ?? 0,
        popularity: rawConfig?.adClaim?.popularity ?? 0,
      },
    };
  };


  const saveConfig = () => {
    setConfirmPopup(true);  // open confirmation alert
  };

  
  // Fetch Config
  const fetchConfig = async () => {
    try {
      // const res = await axios.get(`${API_BASE}/tasks/config`, {
      //   headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      // });
      const url = `users/tasks/config/admin`;
      const res = await helpers.apiCall('GET', url);

      console.log('res', res)
      setConfig(getNormalizedConfig(res.data));
      setLoading(false);
    } catch (error) {
      console.error("Fetch Error:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  // Handle nested input update
  const handleInputChange = (path, value) => {
    const keys = path.split(".");
    setConfig((prev) => {
      const updated = { ...prev };
      let obj = updated;

      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
      }

      obj[keys[keys.length - 1]] = value;
      return updated;
    });
  };

  // Save config to backend
  const onConfirmUpdate = async () => {
    try {
      setSaving(true);
      const url = `users/tasks/config/admin/update`;
      const res = await helpers.apiCall("POST", url, config);
  
      setSuccessPopup(true);   // show success
    } catch (error) {
      console.error("Save Error:", error);
      setErrorPopup(true);     // show error popup
    }
    setSaving(false);
  };
  

  if (loading) return <div>Loading...</div>;
  if (!config) return <div>No Config Found</div>;

  const LABEL_MAP = {
    engagementTasksSummary: "Engagement Task Summary",
    engagementTasks: "Engagement Tasks",
    adClaim: "Ad Claim",
    socialSupportTask: "Social Support Task",
    createTasks: "Create Task",
    bonus: "Daily Engagement Bonus",
    creatorEarningAnalytics: "Creator Earnings Analytics",
    dailyCheckIn: "Daily Check-in",

    starPointWatchMultiply: "Star Point Watch Multiplier",
    popularityWatchMultiply: "Popularity Watch Multiplier",
    starPointlikeMultiply: "Star Point Like Multiplier",
    popularitylikeMultiply: "Popularity Like Multiplier",
  
    watchCount: "Watch Count",
    likeCount: "Like Count",
    starPointWatchCount: "Star Point Per Watch",
    popularityWatchCount: "Popularity Per Watch",
    starPointlikeCount: "Star Point Per Like",
    popularitylikeCount: "Popularity Per Like",
  
    playCount: "Audio Play Count",
    starPoint: "Starpoints Reward",
    popularity: "Popularity Reward",
  
    count: "Required Watch Count",

    reel: "Reel",
    post: "Post",
    audio: "Audio",

    starpointBonus: "Star Points Bonus",
    popularityBonus: "Popularity Bonus",

    starPointEarningAnalyticsWatchCount: "Star Point Per Watch",
    popularityEarningAnalyticsWatchCount: "Popularity Per Watch",
    starPointEarningAnalyticslikeCount: "Star Point Per Like",
    popularityEarningAnalyticslikeCount: "Popularity Per Like",

    day1: "Day 1",
    day2: "Day 2",
    day3: "Day 3",
    day4: "Day 4",
    day5: "Day 5",
    day6: "Day 6",
    day7: "Day 7",
    day8: "Day 8",
    day9: "Day 9",
    day10: "Day 10",
    day1q: "Day 11",
    day12: "Day 12",
    day13: "Day 13",
    day14: "Day 14",
    day15: "Day 15",
  };

  // return (
  //   <>
  //     <div style={{ padding: "20px" }}>
  //       <h2>Task Configuration</h2>
  //       <hr />

  //       {/* Helper function to generate input */}
  //       {Object.entries(config).map(([sectionKey, sectionValue]) => (
  //         <div key={sectionKey} style={{ marginBottom: "20px" }}>
  //           <h3 style={{ textTransform: "capitalize" }}>
  //             {/* {sectionKey} */}
  //             {LABEL_MAP[sectionKey] || sectionKey}
  //           </h3>

  //           {Object.entries(sectionValue).map(([itemKey, itemValue]) => (
  //             <div key={itemKey} style={{ marginLeft: "20px" }}>
  //               <h4 style={{ textTransform: "capitalize" }}>
  //                 {/* {itemKey} */}
  //                 {LABEL_MAP[itemKey] || itemKey}
  //               </h4>

  //               {Object.entries(itemValue).map(([fieldKey, fieldValue]) => (
  //                 <div key={fieldKey} style={{ marginLeft: "20px", marginBottom: "8px" }}>
  //                   <label style={{ marginRight: "10px", width: "200px", display: "inline-block" }}>
  //                     {/* {fieldKey}: */}
  //                     {LABEL_MAP[fieldKey] || fieldKey}:
  //                   </label>
  //                   <input
  //                     type="number"
  //                     value={fieldValue}
  //                     onChange={(e) =>
  //                       handleInputChange(
  //                         `${sectionKey}.${itemKey}.${fieldKey}`,
  //                         Number(e.target.value)
  //                       )
  //                     }
  //                     style={{
  //                       padding: "5px 8px",
  //                       width: "150px",
  //                       borderRadius: "4px",
  //                       border: "1px solid #aaa"
  //                     }}
  //                   />
  //                 </div>
  //               ))}
  //             </div>
  //           ))}
  //         </div>
  //       ))}

  //       <button
  //         onClick={onConfirmUpdate}
  //         disabled={saving}
  //         style={{
  //           padding: "10px 20px",
  //           background: "#007bff",
  //           color: "white",
  //           border: "none",
  //           borderRadius: "5px",
  //           cursor: "pointer",
  //         }}
  //       >
  //         {saving ? "Saving..." : "Save Configuration"}
  //       </button>
  //     </div>
  //     <SweetAlert
  //       show={confirmPopup}
  //       title="Are you sure?"
  //       text="You want to update the Engagement Task Configuration?"
  //       type="warning"
  //       showCancelButton={true}
  //       onConfirm={() => {
  //         setConfirmPopup(false);
  //         onConfirmUpdate();
  //       }}
  //       onCancel={() => setConfirmPopup(false)}
  //     />

  //     <SweetAlert
  //       show={successPopup}
  //       title="Updated!"
  //       text="Configuration updated successfully."
  //       type="success"
  //       onConfirm={() => setSuccessPopup(false)}
  //     />

  //     <SweetAlert
  //       show={errorPopup}
  //       title="Error!"
  //       text="Something went wrong while updating."
  //       type="error"
  //       onConfirm={() => setErrorPopup(false)}
  //     />
  //   </>
  // );
  return (
    <>
      <div className="config-wrapper">
        <div className="page-header">
          <h2>Engagement Task Configuration</h2>
          <p>Manage multipliers and reward settings</p>
        </div>
        <Link to="/dashboard/claim/config/images"><Button variant="contained" color="primary" style={{ marginTop: "10px", marginLeft: "10px", marginBottom: "10px" }} >Edit Claim Type Settings</Button></Link>
        <div className="config-container">
          {Object.entries(config).map(([sectionKey, sectionValue]) => (
            <div key={sectionKey} className="config-card">
              <div className="card-header">
                <h3>{LABEL_MAP[sectionKey] || sectionKey}</h3>
              </div>
  
              <div className="card-body">

                {typeof Object.values(sectionValue)[0] === "object"
                  ? Object.entries(sectionValue).map(([itemKey, itemValue]) => (
                    <div key={itemKey} className="item-section">
                      <h4>{LABEL_MAP[itemKey] || itemKey}</h4>

                      <div className="field-grid">
                        {Object.entries(itemValue).map(([fieldKey, fieldValue]) => (
                          <div key={fieldKey} className="field-group">
                            <label>{LABEL_MAP[fieldKey] || fieldKey}</label>

                            <input
                              type="number"
                              value={fieldValue}
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) =>
                                handleInputChange(
                                  `${sectionKey}.${itemKey}.${fieldKey}`,
                                  Number(e.target.value)
                                )
                              }
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                  : (
                    <div className="item-section">
                      <div className="field-grid">
                        {Object.entries(sectionValue).map(([itemKey, itemValue]) => (
                          <div key={itemKey} className="field-group">
                            <label>{LABEL_MAP[itemKey] || itemKey}</label>

                            <input
                              type="number"
                              value={itemValue}
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) =>
                                handleInputChange(
                                  `${sectionKey}.${itemKey}`,
                                  Number(e.target.value)
                                )
                              }
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </div>

              <div className="card-footer text-right">
                <button
                  onClick={() => {
                    setConfirmPopup(true);
                  }}
                  disabled={saving}
                  className="save-btn"
                >
                  {saving ? "Saving..." : `Save ${LABEL_MAP[sectionKey] || sectionKey}`}
                </button>
              </div>
            </div>
          ))}
        </div>
  
        {/* <div className="save-section">
          <button
            onClick={() => setConfirmPopup(true)}
            disabled={saving}
            className="save-btn"
          >
            {saving ? "Saving..." : "Save Configuration"}
          </button>
        </div> */}
      </div>
  
      {/* <SweetAlert
        show={confirmPopup}
        title="Are you sure?"
        text="You want to update the Engagement Task Configuration?"
        type="warning"
        showCancelButton={true}
        closeOnClickOutside={false}
        closeOnEsc={false}
        onConfirm={() => {
          setConfirmPopup(false);
          onConfirmUpdate();
        }}
        onCancel={() => setConfirmPopup(false)}
      /> */}

      <Dialog
        open={confirmPopup}
        onClose={() => setConfirmPopup(false)}
        // disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle>Are you sure?</DialogTitle>

        <DialogContent>
          <Typography>
            You want to update the Engagement Task Configuration?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setConfirmPopup(false)}
            color="secondary"
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            onClick={() => {
              setConfirmPopup(false);
              onConfirmUpdate();
            }}
            color="primary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
  
      <SweetAlert
        show={successPopup}
        title="Updated!"
        text="Configuration updated successfully."
        type="success"
        onConfirm={() => setSuccessPopup(false)}
      />
  
      <SweetAlert
        show={errorPopup}
        title="Error!"
        text="Something went wrong while updating."
        type="error"
        onConfirm={() => setErrorPopup(false)}
      />
    </>
  );
};

export default AdminEngagementTasksConfig;
